<template>
  <v-dialog v-model="dialog" scrollable width="650">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Cập nhật vị trí / phòng học</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-4">
        <LocationForm ref="locationForm" :locationData="locationData" />
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer />
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LocationForm from '@/modules/facility/location/LocationForm.vue'
import { mapActions } from 'vuex'

export default {
  name: 'LocationEditDialog',
  components: { LocationForm },
  props: {
    state: Boolean,
    locationData: Object
  },
  data() {
    return {
      dialog: false
    }
  },
  watch: {
    state(val) {
      if (val) {
        this.dialog = true
      }
    }
  },
  methods: {
    ...mapActions('FacilityLocations', ['updateLocation']),
    cancel() {
      this.dialog = false
      if (this.$refs.locationForm) {
        this.$refs.locationForm.resetValidation()
      }
    },
    async save() {
      if (!this.$refs.locationForm.validate()) return

      this.$loading.active = true
      try {
        const payload = this.$refs.locationForm.getData()
        await this.updateLocation(payload)
        this.dialog = false
        this.$emit('updated')
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>
